import {PersonRemove} from "@mui/icons-material";
import {ConfirmIconButton} from "@variocube/app-ui";
import React from "react";
import {BookingUser} from "../../api";
import {useLocalization, useWordingFlavor} from "@smalox/shared";

interface BookingUserRemoveButtonProps {
	user: BookingUser;
	onRemove: (user: BookingUser) => Promise<any>;
}

export function BookingUserRemoveButton({user, onRemove}: BookingUserRemoveButtonProps) {
	const {t} = useLocalization();
	const wordingFlavor = useWordingFlavor();
	return (
		<ConfirmIconButton
			title={t("bookings.users.remove")}
			cancel={t("cancel")}
			onConfirm={() => onRemove(user)}
			icon={<PersonRemove />}
			color="error"
		>
			{t(`bookings.users.confirmRemove.${wordingFlavor}`, user.user)}
		</ConfirmIconButton>
	);
}
